document.addEventListener('click', function (e) {
  var pill = e.target.closest('.nb-size-pill');
  if (!pill || pill.disabled) return;
  e.preventDefault();
  var variantId = pill.getAttribute('data-variant-id');
  if (!variantId || !window.essentialCartApi) return;
  pill.classList.add('is-loading');
  window.essentialCartApi.addItem(parseInt(variantId, 10), 1)
    .then(function () {
      pill.classList.remove('is-loading');
      pill.classList.add('is-added');
      setTimeout(function () {
        pill.classList.remove('is-added');
      }, 1500);
      if (window.essentialCartApi.openCart) {
        window.essentialCartApi.openCart();
      }
    })
    .catch(function (err) {
      pill.classList.remove('is-loading');
      console.error('nb-size-pill add error', err);
    });
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nb-sc__prod-arrow');
  if (!btn) return;
  var viewport = btn.closest('.nb-sc__viewport');
  if (!viewport) return;
  var track = viewport.querySelector('.nb-sc__track');
  if (!track) return;
  var amount = track.clientWidth;
  track.scrollBy({ left: btn.classList.contains('nb-sc__prod-arrow--prev') ? -amount : amount, behavior: 'auto' });
  });